import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import IconsSend from '@mui/icons-material/Send';
import DialogActions from '@mui/material/DialogActions';
import useNotification from '../../../../components/_hook/useNotification';
import { useCreateCompanyKeywordClassificationsMutation } from '../../../../../graphql/mutation/companyKeywordClassification/createCompanyKeywordClassificationsMutation';
import ButtonSubmit from '../../../../components/_button/ButtonSubmit';

interface IProps {
  companyId: string;
  onSubmit?: () => void;
}

const useStyles = makeStyles<Theme, IProps>((theme) => ({
  textareaTextField: {
    borderRadius: 0,
    padding: theme.spacing(1),
  },
  textarea: {
    backgroundColor: theme.palette.mode === 'light' ? '#f3f3f3' : 'inherit',
  },
}));

export default function FormCompanyKeywordCreateClassification(props: IProps) {
  const { t } = useTranslation();
  const classes = useStyles(props);
  const { onSubmit, companyId } = props;
  const { notification } = useNotification();
  const [searchWord, setSearchWord] = useState<string>('');

  const [
    createCompanyKeywordClassificationsMutation,
    { loading: isCreateCompanyKeywordClassifications },
  ] = useCreateCompanyKeywordClassificationsMutation(
    `createdCompanyKeywordClassifications {
				_id
			}`,
    {
      onCompleted: () => {
        notification.success(t('success'));
        if (onSubmit) {
          onSubmit();
        }
      },
      onError: (e) => {
        notification.error(e.message);
      },
    }
  );

  async function createCompanyKeywordClassifications(
    classifications: string[]
  ) {
    await createCompanyKeywordClassificationsMutation({
      variables: {
        companyId,
        classifications,
      },
    });
  }

  return (
    <>
      <DialogTitle>
        {t('add')} {t('classification')}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              placeholder={t('enter_one_per_line_or_separate_by_comma')}
              className={classes.textarea}
              InputProps={{ className: classes.textareaTextField }}
              multiline
              rows="8"
              value={searchWord}
              onChange={(evt) => {
                setSearchWord(evt.target.value);
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonSubmit
          fullWidth
          variant="contained"
          color="primary"
          onClick={async () => {
            const classificationArray = searchWord
              .split(/[\n,]+/g)
              .filter(Boolean);

            if (classificationArray.length) {
              await createCompanyKeywordClassificationsMutation({
                variables: {
                  companyId,
                  classifications: classificationArray,
                },
              });
            }
          }}
          isSubmitting={isCreateCompanyKeywordClassifications}
          label={t('submit')}
          icon={<IconsSend />}
        />
      </DialogActions>
    </>
  );
}
